import { column } from '../../lib/column';
import LocalizeKeys from "../../components/Localize/LocalizeKeys";

function columns(data) {
  return [
    column(data, 'date', { showAs: "date" }, LocalizeKeys.TRANSACTION_DATE),
    column(data, 'event', { showAs: "text" }, LocalizeKeys.TRANSACTION_EVENT),
    // "component": the amount is built as a node so the currency symbol can be an icon.
    column(data, 'amount', { showAs: "component" }, LocalizeKeys.TRANSACTION_AMOUNT),
  ];
}

export { columns };
